export const TOKEN_KEY = "ship-easy-token";

/**
 * 授权token holder
 */
class AuthTokenHolder {
    static setToken(token: any) {
        localStorage.setItem(TOKEN_KEY, token);
    }

    static getToken() {
        let localToken = localStorage.getItem(TOKEN_KEY);
        // 此处在千牛小程序内是必然授权了的，所以此处随便填即可
        // 否则从本地存储内取token
        if (import.meta.env.VITE_IS_QN) {
            return localToken || "MINI_TAOBAO_APP";
        }

        return localToken;
    }

    static clearToken() {
        localStorage.removeItem(TOKEN_KEY);
    }
}

export default AuthTokenHolder;
